export interface AppNavigationInput {
    isAuthenticated: boolean
    registrationPending: boolean
    confirmationToken: string | null
    activationToken: string | null
    resetToken: string | null
    profileCompleted?: boolean
}

export function resolveShowProfileForm(input: AppNavigationInput): boolean {
    const { isAuthenticated, profileCompleted, confirmationToken, activationToken, resetToken } = input
    if (resetToken) {
        return false
    }
    // ActivationSetupForm owns the screen until auth succeeds. After that the token
    // must not block profile completion (token clear can race with the auth update).
    if (activationToken && !isAuthenticated) {
        return false
    }
    return Boolean(confirmationToken) || (isAuthenticated && !profileCompleted)
}

export function resolveShowPending(input: AppNavigationInput): boolean {
    const {
        isAuthenticated,
        registrationPending,
        confirmationToken,
        activationToken,
        resetToken,
    } = input
    return (
        registrationPending
        && !isAuthenticated
        && !confirmationToken
        && !activationToken
        && !resetToken
    )
}
